module.exports = __webpack_public_path__ + "media/images/icons/icons_small/53_shoewomen-9bfcb099f904fdb5c2637d15cecb7c0c.png";